import '../../assets/scss/components/spinner.scss';
import Lottie from 'react-lottie';
import animationData from '../../assets/images/lottie/circular-loader';
const OverlayLoader = () => {
    return (<>
        <div className='vqcp-overlay full'>
            <div className='loader-container'>
                <div className='loader'></div>
            </div>
        </div>
    </>)  
}
// export default OverlayLoader;

const OverlayLoader2 = (props) => {
    const fullscreen = (props.screen === 'full');
    // Opt-in horizontal centering — only for thin/grayscale callers so
    // existing usages stay pixel-identical.
    const shouldCenter = props.thin || props.grayscale;

    const style = {
        overlay: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: shouldCenter ? 'center' : undefined,
            width: '100%',
            height: '100%',
            position: fullscreen ? 'fixed' : 'static',
            top: 0,
            left: 0,
            backgroundColor: (!props.hasOwnProperty('bgColor') || props.bgColor === '') ? '#fff' : (props.bgColor === 'transparent' ? 'rgba(0, 0, 0, 0.5)' : props.bgColor),
            textAlign: 'center',
            zIndex: 9999,
        },
        msg: {
            paddingTop: 16,
            fontSize: 24,
        }
    }
    
    const lottieOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    }

    // Opt-in grayscale filter for the Lottie spinner.
    const lottieStyle = props.grayscale ? { filter: 'grayscale(100%)' } : undefined;

    // Opt-in thin CSS ring spinner (uses `spin` keyframes from spinner.scss).
    const thinSize = props.width || 60;
    const thinSpinnerStyle = {
        width: thinSize,
        height: thinSize,
        border: '3px solid rgba(255, 255, 255, 0.15)',
        borderTopColor: props.grayscale ? '#d0d0d0' : '#cf0b15',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
        boxSizing: 'border-box',
    };

    return (<>
        <div className='vqcp-overlay2' style={ style.overlay }>
            {/* <div className='loader-container'>
                <div className='loader'></div>
                {props.msg && <div style={{ ...style.msg }}>{ props.msg }</div>}
            </div> */}
            {props.thin ? (
                <div style={thinSpinnerStyle} />
            ) : (
                <Lottie
                    options={lottieOptions}
                    width={props.width || 150}
                    height={props.height || 150}
                    style={lottieStyle}
                />
            )}
        </div>
    </>)

    // Sample 
    // <OverlayLoader2 screen='full' bgColor='transparent'/>
    // <OverlayLoader2 screen='full' bgColor='transparent' thin />
}

export { OverlayLoader, OverlayLoader2 }